/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicareComponentEstimate
 */
export interface MedicareComponentEstimate {
    /**
     * 
     */
    component: string;
    /**
     * 
     */
    case_mix_group: string;
    /**
     * 
     */
    case_mix_index: number;
    /**
     * 
     */
    daily_rate: number;
    /**
     * Daily rate after applying the facility wage adjustment.
     */
    adjusted_daily_rate?: number | null;
}

/**
 * Check if a given object implements the MedicareComponentEstimate interface.
 */
export function instanceOfMedicareComponentEstimate(value: object): value is MedicareComponentEstimate {
    if (!('component' in value) || value['component'] === undefined) return false;
    if (!('case_mix_group' in value) || value['case_mix_group'] === undefined) return false;
    if (!('case_mix_index' in value) || value['case_mix_index'] === undefined) return false;
    if (!('daily_rate' in value) || value['daily_rate'] === undefined) return false;
    return true;
}

export function MedicareComponentEstimateFromJSON(json: any): MedicareComponentEstimate {
    return MedicareComponentEstimateFromJSONTyped(json, false);
}

export function MedicareComponentEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareComponentEstimate {
    if (json == null) {
        return json;
    }
    return {
        
        'component': json['component'],
        'case_mix_group': json['case_mix_group'],
        'case_mix_index': json['case_mix_index'],
        'daily_rate': json['daily_rate'],
        'adjusted_daily_rate': json['adjusted_daily_rate'] === undefined ? undefined : json['adjusted_daily_rate'] === null ? null : json['adjusted_daily_rate'],
    };
}

export function MedicareComponentEstimateToJSON(json: any): MedicareComponentEstimate {
    return MedicareComponentEstimateToJSONTyped(json, false);
}

export function MedicareComponentEstimateToJSONTyped(value?: MedicareComponentEstimate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'component': value['component'],
        'case_mix_group': value['case_mix_group'],
        'case_mix_index': value['case_mix_index'],
        'daily_rate': value['daily_rate'],
        'adjusted_daily_rate': value['adjusted_daily_rate'],
    };
}

